import { Modal, ModalService } from "../services/modal.service";
import { Component } from "./component";

export class ModalsComponent extends Component {
  public static htmlDefinition = 'app-modals';

  private locale = 'pl';

  private renderModals(modals: Modal[]) {
    this.innerHTML = '';
    if (modals.length > 0) {
      for (let i = 0; i < modals.length; i++) {
        const modal = modals[i];
        this.innerHTML += `<section class="overflow-y-auto max-h-full z-40 bg-gray-200 px-12 py-8 mx-6 -mt-12 rounded-md shadow-md w-full max-w-screen-lg"><h4 class="font-semibold text-2xl">${modal.title}</h4><div class="py-2">${modal.content}</div><div class="flex justify-end"><button type="close" class="font-semibold px-4 py-2 text-gray-500 bg-gray-300 outline-none focus:shadow hover:shadow rounded-md transition-shadow duration-300 block focus:outline-none">${this.locale === 'pl' ? 'Zamknij' : 'Close'}</button></div></section>`;
      }

      this.classList.value = 'pt-12 pb-4 bg-black bg-opacity-80 opacity-0 h-screen w-screen overflow-hidden fixed top-0 left-0 z-20 flex items-center justify-center';
      document.body.classList.add('overflow-y-hidden');
      setTimeout(() => {
        this.classList.add('duration-100', 'transition-opacity');
        this.classList.remove('opacity-0');
      }, 50);

    } else {
      this.classList.value = '';
      document.body.classList.remove('overflow-y-hidden');
    }

  }


  constructor() {
    super();

    this.locale = document.querySelector('[lang]')?.getAttribute('lang') === 'en' ? 'en' : 'pl';

    this.addEventListener("click", e => {
      if (e.target == this || ((e.target as HTMLElement).getAttribute('type') ?? '') === 'close') {
        ModalService.closeLast();
      }
    });
    ModalService.modals$.subscribe((value: Modal[]) => {
      this.renderModals(value);
    });
  }
}